import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useIntl } from 'react-intl';

import { showModalTop } from '../../../actions';
import { showConfirmationModal } from '../../../actions/App';

import AdminEditButtons from '../EditButtons';
import ErrorBoundary from '../../ErrorBoundary';
import FileUploadAddPrefixSuffix from '../../Upload/AddPrefixSuffix';
import UpgradePlanButton from '../../UpgradePlanButton';
import UpgradeBoard from '../../UpgradeBoard';

import { prefixSuffixLabels, prefixSuffixSeparators } from '../../../helpers/Files';
import { getSetting, getUserSetting } from '../../../helpers/Settings';
import { userHasFeature } from '../../../helpers/Features';

const AdminUserEditPrefixSuffix = (props) => {
  const intl = useIntl();

  const { handlePrefixAndSuffix, showUpgradeButton } = props;

  const settingValue = getUserSetting('file_name_prefix_and_suffix');

  const [includePrefix, setIncludePrefix] = useState(false);
  const [includeSuffix, setIncludeSuffix] = useState(false);

  const [prefixLabel, setPrefixLabel] = useState(prefixSuffixLabels[0].value);
  const [suffixLabel, setSuffixLabel] = useState(prefixSuffixLabels[0].value);

  const [prefixSeparator, setPrefixSeparator] = useState(prefixSuffixSeparators[0].value);
  const [suffixSeparator, setSuffixSeparator] = useState(prefixSuffixSeparators[0].value);

  const handlePrefixLabel = (value, initialized) => {
    setPrefixLabel(value);
    handlePrefixAndSuffix('prefix', 'label', value, initialized);
  };

  const handleSuffixLabel = (value, initialized) => {
    setSuffixLabel(value);
    handlePrefixAndSuffix('suffix', 'label', value, initialized);
  };

  const handlePrefixSeparator = (value, initialized) => {
    setPrefixSeparator(value);
    handlePrefixAndSuffix('prefix', 'separator', value, initialized);
  };

  const handleSuffixSeparator = (value, initialized) => {
    setSuffixSeparator(value);
    handlePrefixAndSuffix('suffix', 'separator', value, initialized);
  };

  const handleIncludePrefix = (value, initialized) => {
    setIncludePrefix(value);
    handlePrefixAndSuffix('prefix', 'include', value, initialized);
  };

  const handleIncludeSuffix = (value, initialized) => {
    setIncludeSuffix(value);
    handlePrefixAndSuffix('suffix', 'include', value, initialized);
  };

  useEffect(() => {
    if (!userHasFeature('file-name-prefix-suffix')) return;

    setIncludePrefix(settingValue.prefix.include);
    setIncludeSuffix(settingValue.suffix.include);

    const newPrefixLabel = prefixSuffixLabels.find(
      label => label.value === settingValue.prefix.label,
    );
    const newSuffixLabel = prefixSuffixLabels.find(
      label => label.value === settingValue.suffix.label,
    );

    const newPrefixSeparator = prefixSuffixSeparators.find(
      separator => separator.value === settingValue.prefix.separator,
    );
    const newSuffixSeparator = prefixSuffixSeparators.find(
      separator => separator.value === settingValue.suffix.separator,
    );

    setPrefixLabel(newPrefixLabel?.value);
    setSuffixLabel(newSuffixLabel?.value);
    setPrefixSeparator(newPrefixSeparator?.value);
    setSuffixSeparator(newSuffixSeparator?.value);
  }, [
    settingValue.prefix.include,
    settingValue.prefix.label,
    settingValue.prefix.separator,
    settingValue.suffix.include,
    settingValue.suffix.label,
    settingValue.suffix.separator,
  ]);

  if (getSetting('file_name_prefix_and_suffix_force_workspace')) {
    return null;
  }

  if (!userHasFeature('file-name-prefix-suffix')) {
    return (
      <ErrorBoundary>
        <div className="tab-content-wrapper p-0">
          <UpgradeBoard feature="file-name-prefix-suffix" />
        </div>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <div className="tab-content-wrapper prefix-suffix-content">
        <h4>
          {intl.formatMessage({ defaultMessage: 'File name prefix & suffix' })}
          {showUpgradeButton && <UpgradePlanButton feature="file-name-prefix-suffix" />}
        </h4>
        <FileUploadAddPrefixSuffix
          includePrefix={includePrefix}
          handleIncludePrefix={handleIncludePrefix}
          includeSuffix={includeSuffix}
          handleIncludeSuffix={handleIncludeSuffix}
          handlePrefixLabel={handlePrefixLabel}
          prefixLabel={prefixLabel}
          handlePrefixSeparator={handlePrefixSeparator}
          prefixSeparator={prefixSeparator}
          handleSuffixLabel={handleSuffixLabel}
          suffixLabel={suffixLabel}
          handleSuffixSeparator={handleSuffixSeparator}
          suffixSeparator={suffixSeparator}
          ignoreDisabled={true}
          identifier="user-settings"
        />
      </div>
      <AdminEditButtons
        {...props}
        hideDelete={true}
      />
    </ErrorBoundary>
  );
};

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
});

const mapDispatchToProps = dispatch => ({
  openConfirmationModal: (params) => {
    dispatch(showConfirmationModal(params));
  },
  handleModal: (name, handleConfirm, editKey = null) => {
    dispatch(showModalTop('ShareTemplateModal', {
      name,
      handleConfirm,
      editKey,
    }));
  },
});

AdminUserEditPrefixSuffix.propTypes = {
  handlePrefixAndSuffix: PropTypes.func.isRequired,
  settings: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  showUpgradeButton: PropTypes.bool,
};

AdminUserEditPrefixSuffix.defaultProps = {
  showUpgradeButton: true,
};

export default connect(mapStateToProps, mapDispatchToProps)(AdminUserEditPrefixSuffix);
